import { useCallback } from "react"
import * as signalR from "@microsoft/signalr"
import { getOrCreateApplicationHubConnection } from "@/modules/recruitment/applications/infrastructure/signalr-service"
import { EmployeeImportStatusResponse } from "../infrastructure/sage300EmployeeImportService"


// Subscribes to the Sage 300 employee-import completion event on the shared
// application hub. The backend pushes only the terminal (Completed/Failed)
// result — progress is still tracked client-side via polling.
export function useSage300ImportHub(organizationId: string | undefined) {
  const onImportCompleted = useCallback(
    (handler: (status: EmployeeImportStatusResponse) => void): (() => void) => {
      if (!organizationId) return () => {}

      const { connection, start } =
        getOrCreateApplicationHubConnection(organizationId)

      if (connection.state === signalR.HubConnectionState.Disconnected) {
        void start()
      }

      connection.on("Sage300EmployeeImportCompleted", handler)

      return () => {
        connection.off("Sage300EmployeeImportCompleted", handler)
      }
    },
    [organizationId],
  )

  return { onImportCompleted }
}
